import styled from 'styled-components';

interface EmailProps {
  suOptinForm?: boolean;
  isEmailValid: boolean;
  disabled?: boolean;
}

export const EmailContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
EmailContainer.displayName = 'EmailContainer';

export const EmailLabel = styled.label<EmailProps>`
  width: 100%;
  margin-bottom: 6px;
  font-size: 3vw;
  ${({ isEmailValid }): string => {
    return isEmailValid
      ? ''
      : 'color: #F32020;';
  }}
`;
EmailLabel.displayName = 'EmailLabel';

export const EmailInput = styled.input<EmailProps>`
  font-size: 3vw;
  box-sizing: border-box;
  width: 100%;
  padding: 0 2vw;
  height: 7.7vh;
  border-radius: 4px;
  outline: none;
  border: 1px solid ${({ isEmailValid }): string => {
    return isEmailValid
      ? '#BBB'
      : '#F32020';
  }
};
  ${({ disabled }): string => {
    return disabled === true
      ? `
color: initial;
border: none;
background: inherit;
padding-left: unset;
font-weight: bolder;   
text-align: center;   
`
      : '';
  }
}
`;
EmailInput.displayName = 'EmailInput';

// SU STYLE EMAIL :
export const EmailWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 70vw;
  margin: 0 auto;
`;
EmailWrapper.displayName = 'EmailWrapper';

export const SuEmailLabel = styled.label`
	font-size: 2.5vh;
	font-stretch: semi-expanded;
	margin-bottom: 1.5vh;
	color: rgb(0, 118, 136);
	font-weight: 500;
	margin-bottom: 6px;
`;
SuEmailLabel.displayName = 'SuEmailLabel';

export const EmailInputWrapper = styled.div`
  display: flex;
  align-items: center;
  border: 1px solid rgb(0, 118, 136);
  border-radius: .5vh;
  overflow: hidden;
  background-color: white;
  height: 7vh;
`;
EmailInputWrapper.displayName = 'EmailInputWrapper';

export const SuEmailInput = styled.input`
  flex: 1;
  border: none;
  padding: 1vh 1vw;
  font-size: 2.5vh;
  font-weight: lighter;
  color: grey;
  height: 5vh;
  &:focus {
    outline: none;
  }
`;
SuEmailInput.displayName = 'SuEmailInput';
